export enum PerfilUser {
  ADMIN = 1,
  NORMAL = 0,
}
